// extracted by mini-css-extract-plugin
export var label = "_r9-0";
export var link = "_r9-1";